/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Delete_BodyInputs */

const en_us2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conversation is erased for good and cannot be recovered.`)
};

const pt_br2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conversa é apagada para sempre e não tem como recuperar.`)
};

const es_419_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversación se borra para siempre y no se puede recuperar.`)
};

const pt_pt2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conversa é apagada para sempre e não pode ser recuperada.`)
};

const fr_fr2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversation est effacée définitivement et ne peut pas être récupérée.`)
};

const de_de2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Unterhaltung wird endgültig gelöscht und lässt sich nicht wiederherstellen.`)
};

const it_it2_coach_manage_delete_body = /** @type {(inputs: Coach_Manage_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversazione viene cancellata per sempre e non si può recuperare.`)
};

/**
* | output |
* | --- |
* | "The conversation is erased for good and cannot be recovered." |
*
* @param {Coach_Manage_Delete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_delete_body = /** @type {((inputs?: Coach_Manage_Delete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Delete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_delete_body(inputs)
	if (locale === "es-419") return es_419_coach_manage_delete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_delete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_delete_body(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_delete_body(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_delete_body(inputs)
	return en_us2_coach_manage_delete_body(inputs)
});
export { coach_manage_delete_body as "coach-manage.delete_body" }